import { useCallback } from 'react'
import { useHistory } from 'react-router-dom'
import { useAuth } from '../../context/Auth'
import { LocalStorage } from '../../packages/storage/localStorage'
import { paths } from '../../routes/paths'

export const useLogout = () => {
  const auth = useAuth()
  const history = useHistory()

  return useCallback(async () => {
    const storage = await LocalStorage.getItem('budget-flow-store')

    const updatedStorage = storage.delete('authToken')

    await LocalStorage.setItem('budget-flow-store', updatedStorage)

    auth.dispatch({ type: '@auth/unauthorize' })

    history.replace(paths.login)
  }, [auth, history])
}
